import * as React from 'react';
import { useEffect, useState } from 'react';
import { List, ListItem, ListItemAvatar, ListItemText, Box, Divider, Typography } from '@mui/material';
import { ThemeClient } from '../contexts/Theme';
import Logo from '../components/Logo';
import Navbar from '../Navbar';

import { supabase } from '../supabaseClient';

import { useAuth } from '../contexts/auth';
import { useCode } from '../contexts/Code';
import { useCompany } from '../contexts/Company';

import MessageList from '../components/messages/MessageList';
import Navegation from '../components/Navegation'

const Messages = () => {
  const [messages, setMessages] = useState([]);

  const { user } = useAuth();
  const company = useCompany();

  useEffect(() => {
    console.log(user)
  }, []);

  return (
    <ThemeClient>
      <Navbar title={company?.id === 45 ? 'Messages' : 'Mensajes'} />
      <Logo
        style={{
          height: 'auto',
          maxWidth: '100%',
          marginTop: '2rem',
          marginBottom: '2rem',
        }}
      />
      <Box
        sx={{
          marginTop: 2,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <MessageList companyId={company?.id} />
      </Box>
      <Navegation />

    </ThemeClient>
  );
};

export default Messages;